import {
  BaseInvoiceDto,
  CreateUpdateBaseInvoiceDto,
  CustomerDocDefaultValueDto,
  CustomerInvoiceService,
} from '@digiwall/goliath-documents/proxy';
import { TextTemplateDto } from '@digiwall/core/proxy';
import {
  BaseCustomerDocDetail,
  ICustomerDocService,
} from '../base-customer-docs/base-customer-doc-detail';
import { PeppolTextTemplateSenderComponent } from '../text-templates/peppol-text-template-sender.component';
import { SendTextTemplateOptions } from '../base-docs/detail/send-text-template-options';

export abstract class BaseInvoiceDocDetail<
  TDocService extends ICustomerDocService<TDocDto, TCreateUpdateDto, TDefaultValueDto>,
  TDocDto extends BaseInvoiceDto,
  TCreateUpdateDto extends CreateUpdateBaseInvoiceDto,
  TDefaultValueDto extends CustomerDocDefaultValueDto,
> extends BaseCustomerDocDetail<TDocService, TDocDto, TCreateUpdateDto, TDefaultValueDto> {
  protected sendTextTemplate(
    textTemplate: TextTemplateDto,
    options: SendTextTemplateOptions = null,
  ): void {
    this.subscriptionService.addOne(
      (this.docService as unknown as CustomerInvoiceService).createUBLFile(this.entity.id),
      response => {
        super.sendTextTemplate(textTemplate, {
          textTemplateComponent: PeppolTextTemplateSenderComponent,
          fillSignals: (componentInstance: PeppolTextTemplateSenderComponent) => {
            componentInstance.entity.set(this.entity);
            if (response != null) componentInstance.attachments?.push(response);
          },
        });
      },
      error => {
        super.sendTextTemplate(textTemplate, {
          textTemplateComponent: PeppolTextTemplateSenderComponent,
          fillSignals: (componentInstance: PeppolTextTemplateSenderComponent) => {
            componentInstance.entity.set(this.entity);
          },
        });
      },
    );
  }
}
